module.exports = __webpack_public_path__ + "img/logo-nextalert.27dd8449.png";